import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class PacientesService {

    constructor(
      private api: ApiService
    ) {}

    /* -------------------------------------------------------------------------- */
    /*                              BUSCAR PACIENTES                              */
    /* -------------------------------------------------------------------------- */
    buscarPaciente(_token, limit, ofset, paciente, tipoBusqueda) {
      return this.api.post<{
        rows: any[];
        pagination: { limit: number; offset: number; total: number };
      }>('/persons/patients/list', {
        limit: Number(limit) || 10,
        offset: Number(ofset) || 0,
        search: paciente || 'vacio',
        searchType: tipoBusqueda || 'NOM_CLI'
      }).pipe(
        map((resp) => ({
          ...resp,
          total: resp.pagination.total
        }))
      );
    }


    /* -------------------------------------------------------------------------- */
    /*                          OBTENER PACIENTES NORMAL                          */
    /* -------------------------------------------------------------------------- */
    mostrarPacientesNormal(_token,item, valor) {
      return this.api.post<{ rows: any[] }>('/persons/patients/search', {
        field: item,
        value: valor
      });
    }


    /* -------------------------------------------------------------------------- */
    /*                            BUSCAR DATA PERSONAS                            */
    /* -------------------------------------------------------------------------- */
    buscarDataPersona(identificacion){

      return this.api.post('/persons/patients/identity/lookup', {
        identification: identificacion
      }).pipe(
        map((resp) => JSON.stringify(resp)),
        catchError(() => of(JSON.stringify({
          domicilio: '',
          fechaNacimiento: '',
          infoAdicional: {},
          nombreCompleto: '',
          sexo: ''
        })))
      );
    }
    

    /* -------------------------------------------------------------------------- */
    /*                                 BUSCAR RUC                                 */
    /* -------------------------------------------------------------------------- */
    buscarDataPersonaRUC(identificacion){

      return this.api.post('/persons/patients/taxpayer/lookup', {
        identification: identificacion
      }).pipe(
        map((resp) => JSON.stringify(resp)),
        catchError(() => of(JSON.stringify([{ razonsocial: '' }])))
      );
    }


    /* -------------------------------------------------------------------------- */
    /*                              GUARDAR PACIENTE                              */
    /* -------------------------------------------------------------------------- */
    guardarPaciente(
      nuevaIdentificacionPaciente,
      identificacionPaciente,
      fechaNacimientoPaciente,
      pais,
      nuevoTelefonoCliente,
      nuevoEmailPaciente, 
      direccionPaciente,
      sexoPaciente,
      nuevaEdadPaciente,
      nuevaIdentificacionPacienteOP,
      identificacionAdicional,
      nombreAdicional,
      direccionAdicional,
      token,
      nombre,
      checkCedula,
      infoAdicional = "{}"){

      return this.api.post('/persons/patients/create', {
        tipoIdentificacion: nuevaIdentificacionPaciente,
        identificacion: identificacionPaciente,
        fechaNacimiento: fechaNacimientoPaciente,
        pais,
        telefono: nuevoTelefonoCliente,
        email: nuevoEmailPaciente,
        direccion: direccionPaciente,
        sexo: sexoPaciente,
        edad: nuevaEdadPaciente,
        identificacionPacienteOP: nuevaIdentificacionPacienteOP,
        identificacionAdicional,
        nombreAdicional,
        direccionAdicional,
        nombre,
        checkCedula,
        infoAdicional
      }).pipe(map(() => 'ok'));
    }

    /* -------------------------------------------------------------------------- */
    /*                               EDITAR PACIENTE                              */
    /* -------------------------------------------------------------------------- */
    editarPaciente(
      nuevaIdentificacionPaciente,
      identificacionPaciente,
      fechaNacimientoPaciente,
      pais,
      nuevoTelefonoCliente,
      nuevoEmailPaciente, 
      direccionPaciente,
      sexoPaciente,
      nuevaEdadPaciente,
      nuevaIdentificacionPacienteOP,
      identificacionAdicional,
      nombreAdicional,
      direccionAdicional,
      token,
      nombre,
      checkCedula,
      idPaciente){

      return this.api.post('/persons/patients/update', {
        tipoIdentificacion: nuevaIdentificacionPaciente,
        identificacion: identificacionPaciente,
        fechaNacimiento: fechaNacimientoPaciente,
        pais,
        telefono: nuevoTelefonoCliente,
        email: nuevoEmailPaciente,
        direccion: direccionPaciente,
        sexo: sexoPaciente,
        edad: nuevaEdadPaciente,
        identificacionPacienteOP: nuevaIdentificacionPacienteOP,
        identificacionAdicional,
        nombreAdicional,
        direccionAdicional,
        nombre,
        checkCedula,
        idPaciente
      }).pipe(map(() => 'ok'));
    }

  }
